module.exports = __webpack_public_path__ + "img/globe.30ca64d.svg";